import * as Service from "./services";
import * as actionTypes from "./constants";
import moment from "moment";

const getDropdownList = (entity, params, searchParam = {}) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECT_DROPDOWN_REQUEST, entity });
            const res = await Service.getDropdownList(entity, params, searchParam);
            if (res && res.status === 200) {
                const surveyData = res.data;
                if (surveyData.success) {
                    dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECT_DROPDOWN_SUCCESS, response: surveyData, entity });
                } else {
                    dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECT_DROPDOWN_FAILURE, error: surveyData, entity });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ASSET_SURVEY_PROJECT_DROPDOWN_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ASSET_SURVEY_PROJECT_DROPDOWN_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const addSurveyData = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_ASSET_SURVEY_PROJECT_DATA_REQUEST });
            const res = await Service.addSurveyData(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.ADD_ASSET_SURVEY_PROJECT_DATA_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.ADD_ASSET_SURVEY_PROJECT_DATA_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.ADD_ASSET_SURVEY_PROJECT_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_ASSET_SURVEY_PROJECT_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateSurveyData = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_ASSET_SURVEY_PROJECT_DATA_REQUEST });
            const res = await Service.updateSurveyData(id, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UPDATE_ASSET_SURVEY_PROJECT_DATA_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_ASSET_SURVEY_PROJECT_DATA_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_ASSET_SURVEY_PROJECT_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_ASSET_SURVEY_PROJECT_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateSurveyAssetData = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_SURVEY_ASSET_DATA_REQUEST, response: id });
            const res = await Service.updateSurveyAssetData(id, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UPDATE_SURVEY_ASSET_DATA_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_SURVEY_ASSET_DATA_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_SURVEY_ASSET_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_SURVEY_ASSET_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAssetprojectSurveys = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECTS_REQUEST });
            const res = await Service.getAssetprojectSurveys(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_ASSET_SURVEY_PROJECTS_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_ASSET_SURVEY_PROJECTS_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ASSET_SURVEY_PROJECTS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSurveyAssets = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SURVEY_ASSET_REQUEST });
            const res = await Service.getSurveyAssets(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_SURVEY_ASSET_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_SURVEY_ASSET_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SURVEY_ASSET_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSurveyAssetsExport = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SURVEY_ASSET_EXPORT_REQUEST });
            const res = await Service.getSurveyAssets(params, true);
            if (res && res.status === 200) {
                dispatch({
                    type: actionTypes.GET_SURVEY_ASSET_EXPORT_SUCCESS,
                    response: res.data
                });

                const blob = new Blob([res.data]);

                const disposition = res.headers?.["content-disposition"];
                let fileName = `Survey Asset ${moment().format("MM-DD-YYYY")}.xlsx`;

                if (disposition) {
                    const match = disposition.match(/filename="?([^"]+)"?/);
                    if (match?.[1]) {
                        fileName = match[1];
                    }
                }

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                dispatch({
                    type: actionTypes.GET_SURVEY_ASSET_EXPORT_FAILURE,
                    error: res?.response?.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SURVEY_ASSET_EXPORT_FAILURE,
                error: e.response?.data
            });
        }
    };
};

const getInaccessibleSpaceExport = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_INACCESSIBLE_SPACE_EXPORT_REQUEST });
            const res = await Service.getInaccessibleSpaceList(params, true);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_INACCESSIBLE_SPACE_EXPORT_SUCCESS,
                    response: responseData
                });
                const data = responseData;
                const fileName = `Inacessible spaces ${moment().format("MM-DD-YYYY")}.xlsx`;
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                dispatch({
                    type: actionTypes.GET_INACCESSIBLE_SPACE_EXPORT_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_INACCESSIBLE_SPACE_EXPORT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAssetprojectSurveysExport = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECTS_EXPORT_REQUEST });
            const res = await Service.getAssetprojectSurveys(params, true);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_ASSET_SURVEY_PROJECTS_EXPORT_SUCCESS,
                    response: responseData
                });
                const data = responseData;
                const fileName = `ADC Survey Project ${moment().format("MM-DD-YYYY")}.xlsx`;
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                dispatch({
                    type: actionTypes.GET_ASSET_SURVEY_PROJECTS_EXPORT_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ASSET_SURVEY_PROJECTS_EXPORT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getInaccessibleSpaceList = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_INACCESSIBLE_SPACE_REQUEST });
            const res = await Service.getInaccessibleSpaceList(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_INACCESSIBLE_SPACE_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_INACCESSIBLE_SPACE_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_INACCESSIBLE_SPACE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateAssetSurveyProjectsEntityParams = entityParams => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({
                    type: actionTypes.UPDATE_ASSET_SURVEY_PROJECTS_ENTITY_PARAMS_SUCCESS,
                    response: entityParams
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_ASSET_SURVEY_PROJECTS_ENTITY_PARAMS_FAILURE,
                error: entityParams
            });
        }
    };
};

const deleteAssetSurveyProject = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_ASSET_SURVEY_PROJECT_REQUEST });
            const res = await Service.deleteAssetSurveyProject(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                dispatch({ type: actionTypes.DELETE_ASSET_SURVEY_PROJECT_SUCCESS, response: regionData });
            } else {
                dispatch({
                    type: actionTypes.DELETE_ASSET_SURVEY_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_ASSET_SURVEY_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAsseetSurveyProjectById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECT_BY_ID_REQUEST });
            const res = await Service.getAsseetSurveyProjectById(id);
            if (res && res.status === 200) {
                const capitalRequestData = res.data;

                dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECT_BY_ID_SUCCESS, response: capitalRequestData, id });
            } else {
                dispatch({
                    type: actionTypes.GET_ASSET_SURVEY_PROJECT_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ASSET_SURVEY_PROJECT_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getListForAssetSurveyProjectsFilter = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_REQUEST });
            const res = await Service.getListForAssetSurveyProjectsFilter(params);
            if (res && res.status === 200) {
                const filterData = res.data;
                dispatch({
                    type: actionTypes.GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_SUCCESS,
                    response: filterData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getListForSurveyAssetsFilter = (params, isInaccessible) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_REQUEST });
            const res = await Service.getListForSurveyAssetsFilter(params, isInaccessible);
            if (res && res.status === 200) {
                const filterData = res.data;
                dispatch({
                    type: actionTypes.GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_SUCCESS,
                    response: filterData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSurveyAssetById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SURVEY_ASSET_BY_ID_REQUEST });
            const res = await Service.getSurveyAssetById(id);
            if (res && res.status === 200) {
                const capitalRequestData = res.data;

                dispatch({ type: actionTypes.GET_SURVEY_ASSET_BY_ID_SUCCESS, response: capitalRequestData });
            } else {
                dispatch({
                    type: actionTypes.GET_SURVEY_ASSET_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SURVEY_ASSET_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getInaccessibleSpaceById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_INACCESSIBLE_SPACE_BY_ID_REQUEST });
            const res = await Service.getInaccessibleSpaceById(id);
            if (res && res.status === 200) {
                const capitalRequestData = res.data;

                dispatch({ type: actionTypes.GET_INACCESSIBLE_SPACE_BY_ID_SUCCESS, response: capitalRequestData });
            } else {
                dispatch({
                    type: actionTypes.GET_INACCESSIBLE_SPACE_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_INACCESSIBLE_SPACE_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSurveyAssetImagesById = (id, subTab) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SURVEY_ASSET_IMAGES_BY_ID_REQUEST });
            const res = await Service.getSurveyAssetImagesById(id, subTab);
            if (res && res.status === 200) {
                const capitalRequestData = res.data;

                dispatch({ type: actionTypes.GET_SURVEY_ASSET_IMAGES_BY_ID_SUCCESS, response: capitalRequestData });
            } else {
                dispatch({
                    type: actionTypes.GET_SURVEY_ASSET_IMAGES_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SURVEY_ASSET_IMAGES_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAssetSignature = (entityType, entityId) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_SIGNATURE_REQUEST });
            const res = await Service.getAssetSignature(entityType, entityId);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_ASSET_SIGNATURE_SUCCESS, response: res.data });
            } else {
                dispatch({
                    type: actionTypes.GET_ASSET_SIGNATURE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ASSET_SIGNATURE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const resetAssetSignature = () => ({ type: actionTypes.RESET_ASSET_SIGNATURE });

const getSurveyRecommendationImagesById = (id, param = {}) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_REQUEST });
            const res = await Service.getSurveyRecommendationImagesById(id, param);
            if (res && res.status === 200) {
                const capitalRequestData = res.data;

                dispatch({ type: actionTypes.GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_SUCCESS, response: capitalRequestData });
            } else {
                dispatch({
                    type: actionTypes.GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const resetReducer = type => ({ type: actionTypes.RESET_REDUCER, entity: type });

const resetForm = () => ({ type: actionTypes.RESET_FORM });

const getAllDataLogs = (params, mobileLog = false) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_DATA_LOG_REQUEST });
            const res = await Service.getAllDataLogs(params, mobileLog);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.GET_ALL_DATA_LOG_SUCCESS, response: assetSurveyData });
                } else {
                    dispatch({ type: actionTypes.GET_ALL_DATA_LOG_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_DATA_LOG_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_DATA_LOG_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const activityLogRestore = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.RESTORE_DATA_LOG_REQUEST });
            const res = await Service.activityLogRestore(params);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.RESTORE_DATA_LOG_SUCCESS, response: assetSurveyData });
                } else {
                    dispatch({ type: actionTypes.RESTORE_DATA_LOG_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.RESTORE_DATA_LOG_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.RESTORE_DATA_LOG_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const reviewedAssetsCount = (id, isAssetMngView, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_REVIEWED_ASSETS_COUNT_REQUEST });
            const res = await Service.reviewedAssetsCount(id, isAssetMngView, params);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.GET_REVIEWED_ASSETS_COUNT_SUCCESS, response: assetSurveyData });
                } else {
                    dispatch({ type: actionTypes.GET_REVIEWED_ASSETS_COUNT_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_REVIEWED_ASSETS_COUNT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_REVIEWED_ASSETS_COUNT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const transferReviewedAssets = (id, params, isAssetMngView, assetId) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.TRANSFER_REVIEWED_ASSETS_REQUEST });
            const res = await Service.transferReviewedAssets(id, params, isAssetMngView);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.TRANSFER_REVIEWED_ASSETS_SUCCESS, response: assetSurveyData, assetId });
                } else {
                    dispatch({ type: actionTypes.TRANSFER_REVIEWED_ASSETS_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.TRANSFER_REVIEWED_ASSETS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.TRANSFER_REVIEWED_ASSETS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const revertAsset = assetId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.REVERT_MOBILE_ASSET_REQUEST });
            const res = await Service.revertAsset(assetId);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.REVERT_MOBILE_ASSET_SUCCESS, response: assetSurveyData });
                } else {
                    dispatch({ type: actionTypes.REVERT_MOBILE_ASSET_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.REVERT_MOBILE_ASSET_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.REVERT_MOBILE_ASSET_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const CompletedAssetsCount = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_COMPLETED_ASSETS_COUNT_REQUEST });
            const res = await Service.completedAssetsCount(id);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.GET_COMPLETED_ASSETS_COUNT_SUCCESS, response: assetSurveyData });
                } else {
                    dispatch({ type: actionTypes.GET_COMPLETED_ASSETS_COUNT_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_COMPLETED_ASSETS_COUNT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_COMPLETED_ASSETS_COUNT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getSurveyNotesById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SURVEY_ASSET_NOTE_BY_ID_REQUEST });
            const res = await Service.getSurveyNotesById(id);
            if (res && res.status === 200) {
                const capitalRequestData = res.data;

                dispatch({ type: actionTypes.GET_SURVEY_ASSET_NOTE_BY_ID_SUCCESS, response: capitalRequestData });
            } else {
                dispatch({
                    type: actionTypes.GET_SURVEY_ASSET_NOTE_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SURVEY_ASSET_NOTE_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getReasonsById = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_REASONS_BY_ID_REQUEST });
            const res = await Service.getReasonsById(params);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.GET_REASONS_BY_ID_SUCCESS, response: assetSurveyData });
                } else {
                    dispatch({ type: actionTypes.GET_REASONS_BY_ID_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_REASONS_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_REASONS_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const addReason = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_REASON_REQUEST });
            const res = await Service.addReason(params);
            if (res && res.status === 201) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.ADD_REASON_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.ADD_REASON_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.ADD_REASON_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_REASON_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateInaccessibleSpaceSettings = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_INACCESSIBLE_SPACE_SETTINGS_REQUEST });
            const res = await Service.updateInaccessibleSpaceSettings(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UPDATE_INACCESSIBLE_SPACE_SETTINGS_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_INACCESSIBLE_SPACE_SETTINGS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_INACCESSIBLE_SPACE_SETTINGS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_INACCESSIBLE_SPACE_SETTINGS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateSurveyAssetFields = (id, params, isInaccessible, source) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_SURVEY_ASSET_FIELDS_REQUEST });
            const res = await Service.updateSurveyAssetFields(id, params, isInaccessible, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UPDATE_SURVEY_ASSET_FIELDS_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_SURVEY_ASSET_FIELDS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_SURVEY_ASSET_FIELDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_SURVEY_ASSET_FIELDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateAssetImageComment = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_ASSET_IMAGE_COMMENT_REQUEST });
            const res = await Service.updateAssetImageComment(id, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UPDATE_ASSET_IMAGE_COMMENT_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_ASSET_IMAGE_COMMENT_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_ASSET_IMAGE_COMMENT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_ASSET_IMAGE_COMMENT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateSurveyAssetEntityParams = entityParams => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({
                    type: actionTypes.UPDATE_SURVEY_ASSETS_ENTITY_PARAMS_SUCCESS,
                    response: entityParams
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_SURVEY_ASSETS_ENTITY_PARAMS_FAILURE,
                error: entityParams
            });
        }
    };
};

const updateInaccessibleSpaceEntityParams = entityParams => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({
                    type: actionTypes.UPDATE_INACCESSIBLE_SPACE_ENTITY_PARAMS_SUCCESS,
                    response: entityParams
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_INACCESSIBLE_SPACE_ENTITY_PARAMS_FAILURE,
                error: entityParams
            });
        }
    };
};

const getSurveyAssetsCommonDataByIds = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_REQUEST });
            const res = await Service.getSurveyAssetsCommonDataByIds(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const handleMultiAssetUpdate = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_MULTI_SURVEY_ASSET_REQUEST });
            const res = await Service.handleMultiAssetUpdate(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.UPDATE_MULTI_SURVEY_ASSET_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.UPDATE_MULTI_SURVEY_ASSET_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_MULTI_SURVEY_ASSET_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_MULTI_SURVEY_ASSET_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const resetMultiSurveyAssetCommonData = () => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.RESET_MULTI_COMMON_DATA_SUCCESS,
                response: null
            });
        } catch (e) {
            dispatch({
                type: actionTypes.RESET_MULTI_COMMON_DATA_FAILURE,
                error: null
            });
        }
    };
};

const getAllSurveyAssetIds = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_SURVEY_ASSET_IDS_REQUEST });
            const res = await Service.getAllSurveyAssetIds(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                dispatch({ type: actionTypes.GET_ALL_SURVEY_ASSET_IDS_SUCCESS, response: regionData });
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_SURVEY_ASSET_IDS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_SURVEY_ASSET_IDS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSurveyorDropdown = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SURVEYOR_DROPDOWN_REQUEST });
            const res = await Service.getSurveyorDropdown(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_SURVEYOR_DROPDOWN_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_SURVEYOR_DROPDOWN_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SURVEYOR_DROPDOWN_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAssetVoiceNotes = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_VOICE_NOTES_REQUEST });
            const res = await Service.getAssetVoiceNotes(id, params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_ASSET_VOICE_NOTES_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_ASSET_VOICE_NOTES_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ASSET_VOICE_NOTES_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const runWellsFargoScript = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.RUN_WELLS_FARGO_SCRIPT_REQUEST });
            const res = await Service.runWellsFargoScript(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.RUN_WELLS_FARGO_SCRIPT_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.RUN_WELLS_FARGO_SCRIPT_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.RUN_WELLS_FARGO_SCRIPT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const searchAndReplace = (params, cb) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SEARCH_AND_REPLACE_REQUEST });
            const res = await Service.searchAndReplace(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.SEARCH_AND_REPLACE_SUCCESS,
                    response: responseData
                });
                cb && cb(responseData);
            } else {
                dispatch({
                    type: actionTypes.SEARCH_AND_REPLACE_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SEARCH_AND_REPLACE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const findAssetsBeforeReplace = (params, cb) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.FIND_BEFORE_REPLACE_REQUEST });
            const res = await Service.findAssetsBeforeReplace(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.FIND_BEFORE_REPLACE_SUCCESS,
                    response: responseData
                });
                cb && cb();
            } else {
                dispatch({
                    type: actionTypes.FIND_BEFORE_REPLACE_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SEARCH_AND_REPLACE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const deleteVoiceNoteById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_ASSET_BY_ID_VOICE_NOTES_REQUEST });
            const res = await Service.deleteVoiceNoteById(id);
            if (res && res.status === 200) {
                const voiceData = res.data;
                dispatch({ type: actionTypes.DELETE_ASSET_BY_ID_VOICE_NOTES_SUCCESS, response: voiceData });
            } else {
                dispatch({
                    type: actionTypes.DELETE_ASSET_BY_ID_VOICE_NOTES_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_ASSET_BY_ID_VOICE_NOTES_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSuggestionDropdownByClient = clientId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SUGGESTION_DROPDOWN_BY_CLIENT_REQUEST });
            const res = await Service.getSuggestionDropdownByClient(clientId);
            if (res && res.status === 200) {
                const suggestionData = res.data;
                dispatch({ type: actionTypes.GET_SUGGESTION_DROPDOWN_BY_CLIENT_SUCCESS, response: suggestionData });
            } else {
                dispatch({
                    type: actionTypes.GET_SUGGESTION_DROPDOWN_BY_CLIENT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SUGGESTION_DROPDOWN_BY_CLIENT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAssetSurveyProjectFilterDropdown = (param, key) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECT_FILTER_REQUEST, key });
            const res = await Service.getListForAssetSurveyProjectsFilter(param);

            if (res && res.status === 200) {
                const codeData = res.data;
                if (codeData?.length) {
                    dispatch({
                        type: actionTypes.GET_ASSET_SURVEY_PROJECT_FILTER_SUCCESS,
                        response: codeData,
                        key
                    });
                } else {
                    dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECT_FILTER_FAILURE, error: codeData, key });
                }
            } else {
                dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECT_FILTER_FAILURE, error: res.response.data, key });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_PROJECT_FILTER_FAILURE, error: e.response && e.response.data, key });
        }
    };
};

const setAppliedFilterNames = (paramKey, names) => ({ type: actionTypes.SET_APPLIED_FILTER_NAMES, paramKey, names });

const getAssetSurveyFilterDropdown = (param, key) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_FILTER_REQUEST, key });
            const res = await Service.getAssetSurveyFilterDropdown(param);

            if (res && res.status === 200) {
                const codeData = res.data;
                if (codeData?.list?.length) {
                    dispatch({
                        type: actionTypes.GET_ASSET_SURVEY_FILTER_SUCCESS,
                        response: codeData,
                        key
                    });
                } else {
                    dispatch({ type: actionTypes.GET_ASSET_SURVEY_FILTER_FAILURE, error: codeData, key });
                }
            } else {
                dispatch({ type: actionTypes.GET_ASSET_SURVEY_FILTER_FAILURE, error: res.response.data, key });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_FILTER_FAILURE, error: e.response && e.response.data, key });
        }
    };
};

const setCurrentAudio = audioInstance => ({
    type: actionTypes.SET_CURRENT_AUDIO,
    payload: audioInstance
});

const stopCurrentAudio = () => ({
    type: actionTypes.STOP_CURRENT_AUDIO
});

const setLoadingState = isLoading => {
    return {
        type: actionTypes.SET_LOADING_STATE,
        payload: isLoading
    };
};

const getAssetSurveyUniformatDropdown = param => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_UNIFORMAT_REQUEST });
            const res = await Service.getAssetSurveyUniformatDropdown(param);

            if (res && res.status === 200) {
                const codeData = res.data?.data;
                if (codeData) {
                    dispatch({
                        type: actionTypes.GET_ASSET_SURVEY_UNIFORMAT_SUCCESS,
                        response: codeData
                    });
                } else {
                    dispatch({ type: actionTypes.GET_ASSET_SURVEY_UNIFORMAT_FAILURE, error: codeData });
                }
            } else {
                dispatch({ type: actionTypes.GET_ASSET_SURVEY_UNIFORMAT_FAILURE, error: res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_ASSET_SURVEY_UNIFORMAT_FAILURE, error: e.response && e.response.data });
        }
    };
};

const updateSurveyAssetImageGlobal = (data, isRecommendation = false) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_REQUEST });
            const res = await Service.updateSurveyAssetImageGlobal(data, isRecommendation);
            if (res && res.status === 200) {
                const responseData = res.data;
                if (responseData.success) {
                    dispatch({
                        type: actionTypes.UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_SUCCESS,
                        response: responseData
                    });
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_FAILURE,
                        error: responseData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const addDynamicData = serviceFn => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_DYNAMIC_FORM_SUBMIT_REQUEST });
            const res = await serviceFn();
            if (res && [201, 200].includes(res.status)) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_FORM_SUBMIT_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_FORM_SUBMIT_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.ADD_DYNAMIC_FORM_SUBMIT_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_DYNAMIC_FORM_SUBMIT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getDynamicDropdownData = (entity, serviceFn) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_DROPDOWN_DATA_REQUEST, entity });
            const res = await serviceFn();
            if (res && res.status === 200) {
                const regionData = res.data;
                const dropdowndata = Object.values(regionData ?? {}).find(e => Array.isArray(e));
                if (dropdowndata) {
                    dispatch({ type: actionTypes.GET_DYNAMIC_DROPDOWN_DATA_SUCCESS, response: dropdowndata, entity });
                } else {
                    dispatch({ type: actionTypes.GET_DYNAMIC_DROPDOWN_DATA_FAILURE, error: regionData, entity });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_DYNAMIC_DROPDOWN_DATA_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_DYNAMIC_DROPDOWN_DATA_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const resetDynamicDropdownData = () => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.RESET_DYNAMIC_DROPDOWN_DATA_SUCCESS,
                response: null
            });
        } catch (e) {
            dispatch({
                type: actionTypes.RESET_DYNAMIC_DROPDOWN_DATA_FAILURE,
                error: null
            });
        }
    };
};

const resetTableData = () => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.RESET_TABLE_DATA_SUCCESS,
                response: null
            });
        } catch (e) {
            dispatch({
                type: actionTypes.RESET_TABLE_DATA_FAILURE,
                error: null
            });
        }
    };
};

const defaultImageUpdate = (imageId, id, isRecommendation, cb, isInaccessible, params = {}) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_DEFAULT_IMAGE_REQUEST });
            const res = await Service.defaultImageUpdate(imageId, id, isRecommendation, isInaccessible, params);
            if (res && res.status === 200) {
                const responseData = res.data;
                if (responseData.success) {
                    dispatch({
                        type: actionTypes.UPDATE_DEFAULT_IMAGE_SUCCESS,
                        response: responseData
                    });
                    cb && cb();
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_DEFAULT_IMAGE_FAILURE,
                        error: responseData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_DEFAULT_IMAGE_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT_IMAGE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const handleDelete = (id, isRecommendation, cb, type) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_ASSET_IMAGE_REQUEST });
            const res = await Service.handleDelete(id, isRecommendation, type);
            if (res && res.status === 200) {
                const responseData = res.data;
                if (responseData.success) {
                    dispatch({
                        type: actionTypes.DELETE_ASSET_IMAGE_SUCCESS,
                        response: responseData
                    });
                    cb && cb();
                } else {
                    dispatch({
                        type: actionTypes.DELETE_ASSET_IMAGE_FAILURE,
                        error: responseData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_ASSET_IMAGE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_ASSET_IMAGE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getTableSummaryData = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_TABLE_SUMMARY_DATA_REQUEST });
            const res = await Service.getTableSummaryData(params);
            if (res && res.status === 200) {
                const voiceData = res.data;
                dispatch({ type: actionTypes.GET_TABLE_SUMMARY_DATA_SUCCESS, response: voiceData });
            } else {
                dispatch({
                    type: actionTypes.GET_TABLE_SUMMARY_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_TABLE_SUMMARY_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const resetImageReducer = () => ({ type: actionTypes.RESET_IMAGE_REDUCER });

const updateClientEntityParams = (entityParams, type) => {
    return async dispatch => {
        try {
            if (entityParams) {
                if (type === "deliverable") {
                    dispatch({
                        type: actionTypes.UPDATE_CLIENT_DELIVERABLE_ENTITY_PARAMS_SUCCESS,
                        response: entityParams
                    });
                } else
                    dispatch({
                        type: actionTypes.UPDATE_CLIENT_STANDARD_ENTITY_PARAMS_SUCCESS,
                        response: entityParams,
                        entityType: type
                    });
            }
        } catch (e) {
            if (type === "devliverable") {
                dispatch({
                    type: actionTypes.UPDATE_CLIENT_DELIVERABLE_ENTITY_PARAMS_FAILURE,
                    error: entityParams
                });
            } else
                dispatch({
                    type: actionTypes.UPDATE_CLIENT_STANDARD_ENTITY_PARAMS_FAILURE,
                    error: entityParams,
                    entityType: type
                });
        }
    };
};

const getClientStandardList = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_CLIENT_STANDARD_REQUEST });
            const res = await Service.getClientStandardList(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_CLIENT_STANDARD_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_CLIENT_STANDARD_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_CLIENT_STANDARD_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getSyncedData = (type, param) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SYNCED_DATA_REQUEST, response: { type } });
            let res = {};
            res = await Service.getSyncedData(type, param);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_SYNCED_DATA_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_SYNCED_DATA_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SYNCED_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateSurveyClientDelivery = (id, param) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_SURVEY_CLIENT_DELIVERABLE_REQUEST, response: id });
            let res = {};
            res = await Service.updateSurveyClientDeliverable(id, param);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.UPDATE_SURVEY_CLIENT_DELIVERABLE_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.UPDATE_SURVEY_CLIENT_DELIVERABLE_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_SURVEY_CLIENT_DELIVERABLE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getClientDeliverableList = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_CLIENT_DELIVERABLE_REQUEST });
            const res = await Service.getClientDeliverableList(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_CLIENT_DELIVERABLE_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_CLIENT_DELIVERABLE_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_CLIENT_DELIVERABLE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getClientDeliverableFilterList = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_CLIENT_DELIVERABLE_FILTER_REQUEST });
            const res = await Service.getClientDeliverableList(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_CLIENT_DELIVERABLE_FILTER_SUCCESS,
                    response: responseData?.data
                });
            } else {
                dispatch({
                    type: actionTypes.GET_CLIENT_DELIVERABLE_FILTER_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_CLIENT_DELIVERABLE_FILTER_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getUniformatLevelList = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_UNIFORMAT_LEVEL_REQUEST });
            const res = await Service.getUniformatLevelList(params);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_UNIFORMAT_LEVEL_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_UNIFORMAT_LEVEL_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_UNIFORMAT_LEVEL_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getDropdownListForStandards = (entity, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DROPDOWN_LIST_REQUEST, entity });
            const res = await Service.getDropdownListForStandards(entity, params);
            if (res && res.status === 200) {
                const data = res.data;
                if (data) {
                    dispatch({ type: actionTypes.GET_DROPDOWN_LIST_SUCCESS, response: data?.data, entity });
                } else {
                    dispatch({ type: actionTypes.GET_DROPDOWN_LIST_FAILURE, error: data, entity });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_DROPDOWN_LIST_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_DROPDOWN_LIST_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};
const updateSurveyStandard = (id, param, type) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_SURVEY_STANDARD_REQUEST, response: id });
            let res = {};
            res = await Service.updateSurveyStandard(id, param, type);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.UPDATE_SURVEY_STANDARD_SUCCESS,
                    response: responseData
                });
            } else {
                dispatch({
                    type: actionTypes.UPDATE_SURVEY_STANDARD_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_SURVEY_STANDARD_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getSurveyStandardById = (id, type) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SURVEY_STANDARD_BY_ID_REQUEST });
            const res = await Service.getSurveyStandardById(id, type);
            if (res && res.status === 200) {
                const capitalRequestData = res.data;

                dispatch({ type: actionTypes.GET_SURVEY_STANDARD_BY_ID_SUCCESS, response: capitalRequestData, id });
            } else {
                dispatch({
                    type: actionTypes.GET_SURVEY_STANDARD_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SURVEY_STANDARD_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getStandardImagesById = (id, subTab, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_STANDARD_IMAGES_BY_ID_REQUEST });
            const res = await Service.getStandardImagesById(id, subTab, params);
            if (res && res.status === 200) {
                const capitalRequestData = res.data;

                dispatch({ type: actionTypes.GET_STANDARD_IMAGES_BY_ID_SUCCESS, response: capitalRequestData });
            } else {
                dispatch({
                    type: actionTypes.GET_STANDARD_IMAGES_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_STANDARD_IMAGES_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAiAnalyseData = (params, isInitialCall = false) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_AI_ANALYSE_DATA_REQUEST });
            const res = await Service.getAiAnalyseData(params);
            if (res && res.status === 200) {
                const voiceData = res.data;
                dispatch({ type: actionTypes.GET_AI_ANALYSE_DATA_SUCCESS, response: { ...voiceData, isInitialCall } });
            } else {
                dispatch({
                    type: actionTypes.GET_AI_ANALYSE_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_AI_ANALYSE_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const postAiAnalyse = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.POST_AI_ANALYSE_DATA_REQUEST });
            const res = await Service.postAiAnalyse(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.POST_AI_ANALYSE_DATA_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.POST_AI_ANALYSE_DATA_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.POST_AI_ANALYSE_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.POST_AI_ANALYSE_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const clearAiAnalyse = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.CLEAR_AI_ANALYSE_DATA_REQUEST });
            const res = await Service.clearAiAnalyse(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.CLEAR_AI_ANALYSE_DATA_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.CLEAR_AI_ANALYSE_DATA_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.CLEAR_AI_ANALYSE_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.CLEAR_AI_ANALYSE_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const resetAiReducer = type => ({ type: actionTypes.RESET_AI_REDUCER, entity: type });
const patchAiAnalyse = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.PATCH_AI_ANALYSE_DATA_REQUEST });
            const res = await Service.patchAiAnalyse(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.PATCH_AI_ANALYSE_DATA_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.PATCH_AI_ANALYSE_DATA_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.PATCH_AI_ANALYSE_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.PATCH_AI_ANALYSE_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const resetPatchAiAnalyse = () => ({ type: actionTypes.RESET_PATCH_AI_ANALYSIS });
const assetTableAiAnalyse = (isClick = false) => ({ type: actionTypes.ASSET_TABLE_AI_ANALYSIS, entity: isClick });
const getSelectAllStandardList = (type, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_SELECT_ALL_LIST_REQUEST });
            const res = await Service.getSelectAllStandardList(type, params);
            if (res && res.status === 200) {
                const filterData = res.data;
                dispatch({
                    type: actionTypes.GET_SELECT_ALL_LIST_SUCCESS,
                    response: filterData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_SELECT_ALL_LIST_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_SELECT_ALL_LIST_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getStandardTableExport = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_STANDARD_TABLE_EXPORT_REQUEST });
            const res = await Service.getClientStandardList(params, true);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_STANDARD_TABLE_EXPORT_SUCCESS,
                    response: responseData
                });
                const data = responseData;
                const fileName = `Client Standard ${moment().format("MM-DD-YYYY")}.xlsx`;
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                dispatch({
                    type: actionTypes.GET_STANDARD_TABLE_EXPORT_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_STANDARD_TABLE_EXPORT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getUniformatLevelExport = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_UNIFORMAT_TABLE_EXPORT_REQUEST });
            const res = await Service.getUniformatLevelList(params, true);
            if (res && res.status === 200) {
                const responseData = res.data;
                dispatch({
                    type: actionTypes.GET_UNIFORMAT_TABLE_EXPORT_SUCCESS,
                    response: responseData
                });
                const data = responseData;
                const fileName = `UniformatLevel6 ${moment().format("MM-DD-YYYY")}.xlsx`;
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", `${fileName}`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                dispatch({
                    type: actionTypes.GET_UNIFORMAT_TABLE_EXPORT_FAILURE,
                    error: res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_UNIFORMAT_TABLE_EXPORT_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getListForSurveyor = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_SURVEYOR_REQUEST });
            const res = await Service.getListForSurveyor(params);
            if (res && res.status === 200) {
                const filterData = res.data;
                dispatch({
                    type: actionTypes.GET_LIST_FOR_SURVEYOR_SUCCESS,
                    response: filterData
                });
            } else {
                dispatch({
                    type: actionTypes.GET_LIST_FOR_SURVEYOR_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LIST_FOR_SURVEYOR_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const groupSurveyUpdate = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GROUP_SURVEY_UPDATE_REQUEST });
            const res = await Service.groupSurveyUpdate(params);
            if (res && res.status === 200) {
                const filterData = res.data;
                dispatch({
                    type: actionTypes.GROUP_SURVEY_UPDATE_SUCCESS,
                    response: filterData
                });
            } else {
                dispatch({
                    type: actionTypes.GROUP_SURVEY_UPDATE_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GROUP_SURVEY_UPDATE_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const saveAiAnalyseAssetData = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.PATCH_AI_ANALYZE_ASSET_DATA_REQUEST });
            const res = await Service.saveAiAnalyseAssetData(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.PATCH_AI_ANALYZE_ASSET_DATA_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.PATCH_AI_ANALYZE_ASSET_DATA_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.PATCH_AI_ANALYZE_ASSET_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.PATCH_AI_ANALYZE_ASSET_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getAiAnalyseKey = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_AI_ANALYSE_KEY_REQUEST });
            const res = await Service.getAiAnalyseKey(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_ASSET_AI_ANALYSE_KEY_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_ASSET_AI_ANALYSE_KEY_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ASSET_AI_ANALYSE_KEY_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ASSET_AI_ANALYSE_KEY_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getEntityDropdown = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ENTITY_DROPDOWN_REQUEST });
            const res = await Service.getEntityDropdown(params);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.GET_ENTITY_DROPDOWN_SUCCESS, response: assetSurveyData });
                } else {
                    dispatch({ type: actionTypes.GET_ENTITY_DROPDOWN_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ENTITY_DROPDOWN_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ENTITY_DROPDOWN_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getGroupEditProgress = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSET_GROUP_EDIT_PROGRESS_REQUEST });
            const res = await Service.getGroupEditProgress(id, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_ASSET_GROUP_EDIT_PROGRESS_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_ASSET_GROUP_EDIT_PROGRESS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ASSET_GROUP_EDIT_PROGRESS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ASSET_GROUP_EDIT_PROGRESS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const resetGetList = type => ({ type: actionTypes.RESET_GET_REDUCER, entity: type });

const revertAssetDataById = assetId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.REVERT_MOBILE_ASSET_BY_ID_REQUEST });
            const res = await Service.revertAssetDataById(assetId);
            if (res && res.status === 200) {
                const assetSurveyData = res.data;
                if (assetSurveyData?.success) {
                    dispatch({ type: actionTypes.REVERT_MOBILE_ASSET_BY_ID_SUCCESS, response: assetSurveyData });
                } else {
                    dispatch({ type: actionTypes.REVERT_MOBILE_ASSET_BY_ID_FAILURE, error: assetSurveyData });
                }
            } else {
                dispatch({
                    type: actionTypes.REVERT_MOBILE_ASSET_BY_ID_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.REVERT_MOBILE_ASSET_BY_ID_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const resetDataLog = () => ({ type: actionTypes.RESET_DATA_LOG });

const resetADCSurveyProjectTableData = () => {
    return async dispatch => {
        try {
            dispatch({
                type: actionTypes.RESET_ADC_SURVEY_PROJECT_TABLE_DATA_SUCCESS,
                response: null
            });
        } catch (e) {
            dispatch({
                type: actionTypes.RESET_ADC_SURVEY_PROJECT_TABLE_DATA_FAILURE,
                error: null
            });
        }
    };
};

export default {
    deleteVoiceNoteById,
    getDropdownList,
    addSurveyData,
    getAssetprojectSurveys,
    updateAssetSurveyProjectsEntityParams,
    deleteAssetSurveyProject,
    getAsseetSurveyProjectById,
    updateSurveyData,
    resetReducer,
    getListForAssetSurveyProjectsFilter,
    getSurveyAssets,
    getSurveyAssetById,
    getSurveyAssetImagesById,
    getAssetSignature,
    resetAssetSignature,
    updateSurveyAssetData,
    getAllDataLogs,
    reviewedAssetsCount,
    transferReviewedAssets,
    getInaccessibleSpaceList,
    getInaccessibleSpaceById,
    CompletedAssetsCount,
    getSurveyNotesById,
    getReasonsById,
    addReason,
    updateInaccessibleSpaceSettings,
    updateSurveyAssetFields,
    updateAssetImageComment,
    updateSurveyAssetEntityParams,
    updateInaccessibleSpaceEntityParams,
    getAssetprojectSurveysExport,
    getSurveyAssetsExport,
    activityLogRestore,
    getSurveyAssetsCommonDataByIds,
    handleMultiAssetUpdate,
    resetMultiSurveyAssetCommonData,
    getAllSurveyAssetIds,
    getListForSurveyAssetsFilter,
    getSurveyorDropdown,
    getAssetVoiceNotes,
    getSurveyRecommendationImagesById,
    getAssetSurveyFilterDropdown,
    setAppliedFilterNames,
    setCurrentAudio,
    stopCurrentAudio,
    setLoadingState,
    getAssetSurveyUniformatDropdown,
    updateSurveyAssetImageGlobal,
    getAssetSurveyProjectFilterDropdown,
    addDynamicData,
    getDynamicDropdownData,
    resetDynamicDropdownData,
    getSuggestionDropdownByClient,
    defaultImageUpdate,
    resetTableData,
    handleDelete,
    runWellsFargoScript,
    searchAndReplace,
    findAssetsBeforeReplace,
    resetForm,
    getTableSummaryData,
    revertAsset,
    getInaccessibleSpaceExport,
    resetImageReducer,
    updateClientEntityParams,
    getClientStandardList,
    getSyncedData,
    updateSurveyStandard,
    getClientDeliverableList,
    getUniformatLevelList,
    getDropdownListForStandards,
    updateSurveyClientDelivery,
    getSurveyStandardById,
    getClientDeliverableFilterList,
    getStandardImagesById,
    getAiAnalyseData,
    postAiAnalyse,
    resetAiReducer,
    clearAiAnalyse,
    groupSurveyUpdate,
    getListForSurveyor,
    patchAiAnalyse,
    resetPatchAiAnalyse,
    assetTableAiAnalyse,
    getSelectAllStandardList,
    getStandardTableExport,
    getUniformatLevelExport,
    saveAiAnalyseAssetData,
    getAiAnalyseKey,
    getEntityDropdown,
    getGroupEditProgress,
    resetGetList,
    revertAssetDataById,
    resetDataLog,
    resetADCSurveyProjectTableData
};
